var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { JobRole } from '../../enums/workload/job-role';
var JobRolePipe = /** @class */ (function () {
    function JobRolePipe() {
    }
    JobRolePipe.prototype.transform = function (role) {
        switch (role) {
            case (JobRole.Admin):
                {
                    return 'Administrator';
                }
            case (JobRole.Manager):
                {
                    return 'Manager';
                }
            case (JobRole.TeamMember):
                {
                    return 'Team member';
                }
            default:
                {
                    return 'unknown role';
                }
        }
    };
    JobRolePipe = __decorate([
        Pipe({ name: 'jobRole' })
    ], JobRolePipe);
    return JobRolePipe;
}());
export { JobRolePipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiam9iLXJvbGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJqb2Itcm9sZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFpQixNQUFNLGVBQWUsQ0FBQztBQUVwRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFHeEQ7SUFBQTtJQXFCQSxDQUFDO0lBcEJVLCtCQUFTLEdBQWhCLFVBQWlCLElBQWE7UUFDMUIsUUFBUSxJQUFJLEVBQUU7WUFDVixLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQztnQkFDaEI7b0JBQ0ksT0FBTyxlQUFlLENBQUM7aUJBQzFCO1lBQ0wsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUM7Z0JBQ2xCO29CQUNJLE9BQU8sU0FBUyxDQUFDO2lCQUNwQjtZQUNMLEtBQUssQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDO2dCQUNyQjtvQkFDSSxPQUFPLGFBQWEsQ0FBQztpQkFDeEI7WUFDTDtnQkFDSTtvQkFDSSxPQUFPLGNBQWMsQ0FBQztpQkFDekI7U0FDUjtJQUNMLENBQUM7SUFwQlEsV0FBVztRQUR2QixJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLENBQUM7T0FDYixXQUFXLENBcUJ2QjtJQUFELGtCQUFDO0NBQUEsQUFyQkQsSUFxQkM7U0FyQlksV0FBVyJ9